import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { useDispatch, useSelector } from "react-redux";
import notificationReducer from "./slices/notificationSlice";
import formReducer from "./slices/flowFormSlice";
import documentReducer from "./slices/documentSlice";

const rootReducer = combineReducers({
  notificationReducer,
  formReducer,
  documentReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false
  })
});



// export const useAppDispatch = () => useDispatch();
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector = useSelector;
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof rootReducer>;

